/* fotomalovanky.cz — product page behaviour (fm)
   Owns: app-load guard for the Easify options (fails open after an extended
   timeout), upload counter (uploaded files only), Czech rewrite of the app's
   English validation strings, numbering of the app-rendered steps, sticky
   mobile add-to-cart (proxy click on the real button), add-to-cart feedback
   (validation / network failure), PDF-aware trust lines, and consent-gated
   PostHog captures. Re-initialises on theme-editor section loads.
   Origin re-renders #price-*, variant-selects and the submit button state on
   every variant change, so nothing here is stored inside those nodes.
   Document-level listeners and pub/sub subscriptions are registered once and
   resolve the live form on each event, so editor re-renders never stack them. */
(function () {
  'use strict';

  var S = window.fmStrings || {};
  var CFG = window.fmProductConfig || {};
  var APP_SELECTOR = '.tpo_option-set-wrapper, .tpo_option-label';
  var DETECT_INTERVAL = 250;
  var WARN_MS = 5000;      // show "form did not load" after this
  var FAIL_OPEN_MS = 15000; // lift the lock after this — a lost sale costs more than a follow-up e-mail
  var COUNTER_INTERVAL = 700;
  // Easify writes finished uploads into hidden inputs named after the option's property
  // ("Fotka (4)-1" on the Czech set, "Fotos (4)-1" on the German one).
  var UPLOAD_PROP_SELECTOR = 'input[name^="properties[Fotka ("], input[name^="properties[Fotos ("]';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- PostHog: consent-gated queue ------------------------------ */
  var queue = [];
  var flushTimer = null;

  // 'yes' only on an explicit allow from Shopify's Customer Privacy API. When the API
  // is absent we defer to PixieHog: it only loads posthog-js when Shopify lets it.
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') {
      return (window.posthog && window.posthog.__loaded) ? 'yes' : 'pending';
    }
    try {
      var v = cp.analyticsProcessingAllowed();
      if (v === true || v === 'yes') return 'yes';
      if (v === false || v === 'no') return 'no';
      return 'pending';
    } catch (e) {
      return 'pending';
    }
  }

  function flush() {
    var c = consentState();
    if (c === 'no') { queue = []; return; }
    if (c !== 'yes' || !window.posthog || typeof window.posthog.capture !== 'function') return;
    while (queue.length) {
      var item = queue.shift();
      try { window.posthog.capture(item[0], item[1]); } catch (e) { /* ignore */ }
    }
  }

  function capture(name, props) {
    props = props || {};
    props.fm_page = 'product';
    queue.push([name, props]);
    flush();
    if (!flushTimer) {
      var tries = 0;
      flushTimer = setInterval(function () {
        flush();
        if (!queue.length || ++tries > 60) { clearInterval(flushTimer); flushTimer = null; }
      }, 1000);
    }
  }

  document.addEventListener('visitorConsentCollected', flush);

  /* ---------- helpers ----------------------------------------------------- */
  function els() {
    var info = document.querySelector('product-info');
    var form = info && info.querySelector('form[data-type="add-to-cart-form"]');
    return {
      info: info,
      form: form,
      btn: form && form.querySelector('.product-form__submit'),
      msg: form && form.querySelector('[data-fm-msg]'),
      sticky: document.querySelector('[data-fm-sticky-product]')
    };
  }

  function showMsg(msg, text) { if (!msg) return; msg.textContent = text; msg.hidden = !text; }
  function appDetected() { return !!document.querySelector(APP_SELECTOR); }
  function isVisible(el) { return !!(el && el.offsetParent !== null); }
  function isLocked(form) { return !!form && form.getAttribute('data-fm-locked') === '1'; }
  function leadingInt(s) { var m = String(s || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function czPlural(n) { return n === 1 ? S.missingOne : (n >= 2 && n <= 4 ? S.missingFew : S.missingMany); }
  function fmt(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function stepName(label) {
    if (!label) return 'unknown';
    var clone = label.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('.fm-num, .tpo_option-required-indicator, .tpo_option-tooltip, .fm-counter'), function (n) { n.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim().slice(0, 40) || 'unknown';
  }

  var state = { count: CFG.initialCount || 4, isPdf: !!CFG.initialIsPdf, timedOut: false, startedAt: 0 };
  var timers = [];
  function track(id) { timers.push(id); return id; }
  function clearTimers() { timers.forEach(clearInterval); timers = []; }

  /* ---------- guard ------------------------------------------------------- */
  function initGuard(E) {
    if (!CFG.guard || CFG.designMode || !E.form) return;
    if (appDetected()) return;

    state.startedAt = Date.now();
    E.form.setAttribute('data-fm-locked', '1');

    var poll = track(setInterval(function () {
      var elapsed = Date.now() - state.startedAt;
      if (appDetected()) {
        clearInterval(poll);
        var late = state.timedOut;
        E.form.removeAttribute('data-fm-locked');
        showMsg(E.msg, '');
        if (late) capture('easify_not_loaded', { detected_by: 'late', after_ms: elapsed });
        onAppReady(E);
      } else if (!state.timedOut && elapsed > WARN_MS) {
        state.timedOut = true;
        showMsg(E.msg, S.guardTimeout);
        capture('easify_not_loaded', { detected_by: 'timeout' });
      } else if (elapsed > FAIL_OPEN_MS) {
        // fail open: keep the warning, but never block a purchase indefinitely
        clearInterval(poll);
        E.form.removeAttribute('data-fm-locked');
        capture('easify_not_loaded', { detected_by: 'fail_open', after_ms: elapsed });
      }
    }, DETECT_INTERVAL));
  }

  // capture-phase on document: runs before Origin's product-form submit handler
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isLocked(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showMsg(form.querySelector('[data-fm-msg]'), state.timedOut ? S.guardTimeout : S.guardLoading);
    capture('atc_tapped_while_locked', { timed_out: state.timedOut });
  }, true);

  /* ---------- app-ready: numbering, Czech messages, counter --------------- */
  function numberAppSteps(form) {
    if (!form) return;
    var n = CFG.optionCount || 2;
    Array.prototype.forEach.call(form.querySelectorAll('.tpo_option-container'), function (c) {
      var label = c.querySelector('.tpo_option-label');
      if (!label) return;
      var span = label.querySelector('.fm-num');
      if (!isVisible(c)) { if (span) span.remove(); return; }
      n += 1;
      if (!span) {
        span = document.createElement('span');
        span.className = 'fm-num fm-num--sm fm-num--app';
        span.setAttribute('aria-hidden', 'true');
        label.insertBefore(span, label.firstChild);
      }
      var text = String(n);
      if (span.textContent !== text) span.textContent = text;
    });
  }

  function rewriteEnglish(node) {
    var m = node.textContent.match(/upload at least (\d+) file/i);
    if (m) {
      var missing = parseInt(m[1], 10);
      node.textContent = fmt(czPlural(missing), { n: missing });
    }
  }

  function rewriteAllErrors(form) {
    Array.prototype.forEach.call(form.querySelectorAll('.tpo_error-message'), rewriteEnglish);
  }

  var errorObserver = null;
  function watchErrors(E) {
    if (errorObserver) errorObserver.disconnect();
    var pending = false;
    errorObserver = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Easify re-renders its options after a variant change; re-number whenever the form changes
      requestAnimationFrame(function () { pending = false; rewriteAllErrors(E.form); numberAppSteps(E.form); });
    });
    errorObserver.observe(E.form, { childList: true, characterData: true, subtree: true });
    rewriteAllErrors(E.form);
  }

  function currentUploadContainer(form) {
    var containers = form.querySelectorAll('.tpo_option-container');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].querySelector('input[type="file"]') && isVisible(containers[i])) return containers[i];
    }
    return null;
  }

  // "Nahráno" counts completed uploads only: Easify writes each finished file's URL
  // into a hidden "Fotka (N)-i" input; selected-but-not-yet-uploaded files don't count.
  function uploadedCount(form, container) {
    var re = new RegExp('^properties\\[(Fotka|Fotos) \\(' + state.count + '\\)-\\d+\\]$');
    var scope = container.querySelector(UPLOAD_PROP_SELECTOR) ? container : form;
    var n = 0;
    Array.prototype.forEach.call(scope.querySelectorAll(UPLOAD_PROP_SELECTOR), function (i) {
      if (re.test(i.name) && i.value) n++;
    });
    return n;
  }

  var counterEl = null;
  var lastCounter = '';
  var counterTimer = null;

  function updateCounter(E) {
    var c = currentUploadContainer(E.form);
    if (!c) { if (counterEl) counterEl.hidden = true; return true; }
    if (!counterEl) {
      counterEl = document.createElement('div');
      counterEl.className = 'fm-counter';
      counterEl.setAttribute('data-fm-counter', '');
      counterEl.setAttribute('aria-live', 'polite');
    }
    if (counterEl.parentElement !== c) {
      var anchor = c.querySelector('.tpo_option-label-container') || c.querySelector('.tpo_option-label') || c;
      anchor.insertAdjacentElement('afterend', counterEl);
    }
    var n = uploadedCount(E.form, c);
    var done = n >= state.count;
    var text = fmt(S.counter, { n: n, of: state.count });
    counterEl.hidden = false;
    counterEl.classList.toggle('fm-counter--done', done);
    if (text !== lastCounter) {
      counterEl.textContent = text;
      if (lastCounter) capture('upload_progress', { n: n, of: state.count });
      lastCounter = text;
    }
    return done;
  }

  // Easify fills the hidden inputs asynchronously with no DOM event we can rely on,
  // so poll while an upload is incomplete and stop once the count is reached.
  function startCounterPolling(E) {
    if (counterTimer) clearInterval(counterTimer);
    if (updateCounter(E)) return;
    counterTimer = track(setInterval(function () {
      if (updateCounter(E)) { clearInterval(counterTimer); counterTimer = null; }
    }, COUNTER_INTERVAL));
  }

  function onAppReady(E) {
    numberAppSteps(E.form);
    watchErrors(E);
    startCounterPolling(E);
    if (E.form.dataset.fmChangeBound !== '1') {
      E.form.dataset.fmChangeBound = '1';
      E.form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'file') setTimeout(function () { startCounterPolling(E); }, 50);
      });
    }
  }

  /* ---------- sticky bar (mobile) ---------------------------------------- */
  var stickyObserver = null;
  var stickyHiddenByFocus = false;
  var stickyLastVisible = false;
  var coarsePointer = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  function showSticky(bar, v) {
    if (!bar) return;
    bar.classList.toggle('is-visible', v);
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    if (v) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
  }

  function initSticky(E) {
    var bar = E.sticky;
    if (!bar || !E.btn) return;
    if (stickyObserver) stickyObserver.disconnect();
    if ('IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(function (entries) {
        stickyLastVisible = !entries[0].isIntersecting;
        showSticky(bar, stickyLastVisible && !stickyHiddenByFocus);
      }, { threshold: 0 });
      stickyObserver.observe(E.btn);
    } else {
      var onScroll = function () {
        var r = E.btn.getBoundingClientRect();
        stickyLastVisible = r.bottom < 0 || r.top > window.innerHeight;
        showSticky(bar, stickyLastVisible && !stickyHiddenByFocus);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    if (bar.dataset.fmInit !== '1') {
      bar.dataset.fmInit = '1';
      bar.querySelector('[data-fm-sticky-btn]').addEventListener('click', function () {
        var real = els().btn;
        if (real && !real.disabled) real.click();
      });
    }
    showSticky(bar, false);
    syncStickyButton(E);
  }

  document.addEventListener('focusin', function (e) {
    if (!coarsePointer) return;
    var t = e.target;
    if (t && ((t.tagName === 'INPUT' && /text|email|tel|search|number/.test(t.type)) || t.tagName === 'TEXTAREA')) {
      stickyHiddenByFocus = true;
      showSticky(els().sticky, false);
    }
  });
  document.addEventListener('focusout', function () {
    if (!coarsePointer) return;
    stickyHiddenByFocus = false;
    showSticky(els().sticky, stickyLastVisible);
  });

  function syncStickyButton(E) {
    var bar = E.sticky; if (!bar) return;
    var proxy = bar.querySelector('[data-fm-sticky-btn]');
    var price = bar.querySelector('[data-fm-sticky-price]');
    var real = document.querySelector('#ProductSubmitButton-' + CFG.sectionId);
    if (real && proxy) {
      var span = real.querySelector('span');
      var label = span ? span.textContent.trim() : proxy.textContent;
      if (proxy.textContent !== label) proxy.textContent = label;
      proxy.disabled = real.disabled;
    }
    var priceRoot = document.querySelector('#price-' + CFG.sectionId);
    var priceNode = priceRoot && (priceRoot.querySelector('.price--on-sale .price-item--sale') || priceRoot.querySelector('.price-item--regular'));
    if (priceNode) {
      var p = priceNode.textContent.trim();
      if (price && price.textContent !== p) price.textContent = p;
      // live price next to step 2 and inside the add-to-cart button
      Array.prototype.forEach.call(document.querySelectorAll('[data-fm-live-price]'), function (node) {
        if (node.textContent !== p) node.textContent = p;
      });
    }
  }

  /* ---------- consent banner offset -------------------------------------- */
  // Shopify's cookie banner sits at the bottom of the viewport; reserve its real height.
  var bannerObserver = null;
  function watchConsentBanner() {
    if (!('ResizeObserver' in window)) return;
    var apply = function () {
      var banner = document.getElementById('shopify-pc__banner');
      var h = banner && isVisible(banner) ? banner.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--fm-consent-offset', Math.round(h) + 'px');
      if (banner && !bannerObserver) {
        bannerObserver = new ResizeObserver(apply);
        bannerObserver.observe(banner);
      }
    };
    apply();
    setTimeout(apply, 1500);
    document.addEventListener('visitorConsentCollected', function () { setTimeout(apply, 300); });
  }

  /* ---------- submit feedback (registered once) -------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.product-form__submit');
    if (!b) return;
    var E = els();
    if (!E.form || !E.form.contains(b)) return;
    capture('atc_clicked', { count: state.count, pdf: state.isPdf, locked: isLocked(E.form) });
    setTimeout(function () {
      var err = Array.prototype.filter.call(E.form.querySelectorAll('.tpo_error-message'), function (x) { return isVisible(x) && x.textContent.trim(); })[0];
      if (!err) return;
      rewriteEnglish(err);
      err.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      var container = err.closest('.tpo_option-container');
      capture('atc_validation_failed', { step: stepName(container && container.querySelector('.tpo_option-label')) });
    }, 350);
  }, true);

  /* ---------- variant overlays ------------------------------------------- */
  function applyFormat() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-format]'), function (el) {
      el.hidden = (el.getAttribute('data-fm-format') === 'pdf') !== state.isPdf;
    });
  }

  var subscribed = false;
  function subscribeOnce() {
    if (subscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribed = true;
    // an option was tapped: Origin disables the real button until the new variant is rendered
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
      var E = els();
      var proxy = E.sticky && E.sticky.querySelector('[data-fm-sticky-btn]');
      if (proxy) proxy.disabled = true;
    });
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data;
      if (!d || !d.variant || (d.sectionId && CFG.sectionId && d.sectionId !== CFG.sectionId)) return;
      var v = d.variant;
      state.count = leadingInt(v.option2) || state.count;
      state.isPdf = /pdf/i.test(String(v.option1));
      applyFormat();
      var E = els();
      setTimeout(function () { syncStickyButton(E); numberAppSteps(E.form); startCounterPolling(E); }, 60);
      // the app swaps the visible upload option a moment later; number again once it has settled
      setTimeout(function () { syncStickyButton(E); numberAppSteps(E.form); startCounterPolling(E); }, 900);
    });
    subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
      if (!ev || ev.source !== 'product-form' || !ev.networkError) return;
      showMsg(els().msg, S.requestFailed);
      capture('atc_request_failed', { error: String(ev.errors).slice(0, 80) });
    });
  }

  /* ---------- init -------------------------------------------------------- */
  function init() {
    var E = els();
    if (!E.form || !E.btn) return; // buy_buttons block removed: nothing to do
    subscribeOnce();
    if (E.form.dataset.fmReady === '1') { syncStickyButton(E); return; }
    E.form.dataset.fmReady = '1';
    clearTimers();
    initGuard(E);
    initSticky(E);
    watchConsentBanner();
    applyFormat();
    if (appDetected()) onAppReady(E);
    else document.addEventListener('tpo_loaded', function () { var L = els(); if (L.form && !isLocked(L.form)) onAppReady(L); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
  document.addEventListener('shopify:section:unload', function () { clearTimers(); if (errorObserver) errorObserver.disconnect(); });
})();
